import { useClaimAllRewards } from '@wwe-portal/web/providers/queries/rbe.mutation';
import { Button } from '@wwe-portal/ui/components/button/button';
import { showDialog } from '@wwe-portal/ui/components/dialog';
import { useIsAuthenticated } from '@wwe-portal/web/providers/stores/auth-store';
import { FC, useMemo } from 'react';
import { EventData, UserEventProgress } from '@wwe-portal/entities/rbe.type';
import { LoginDialogPortable } from '../auth/login-dialog';
import { useProcessingDialog } from '@wwe-portal/web/hooks/payment/processing-dialog';
import { VERIFY_DURATION_MS } from '@wwe-portal/web/utils/constants/offer';
import { useTranslations } from 'next-intl';
import { wait } from '@wwe-portal/ui/lib/timer';

export const ClaimAllButton: FC<{
  userProgress: UserEventProgress | undefined;
  eventData: EventData;
}> = ({ userProgress, eventData }) => {
  const { mutate: claimAll, isPending: isClaimingAll } = useClaimAllRewards();
  const isAuthenticated = useIsAuthenticated();
  const canClaimAll = useMemo(() => {
    return (
      userProgress &&
      userProgress.milestones.some((milestone) => milestone.type === 'claim')
    );
  }, [userProgress]);

  const t = useTranslations();

  const { showProcess, showSuccess } = useProcessingDialog({
    progressData: {
      title: t('reward_title_load'),
      description: t('reward_description_load'),
      duration: VERIFY_DURATION_MS,
    },
    successData: {
      title: t('reward_claimed'),
      description: t('reward_description_successful'),
    },
  });

  const handleClaimAll = () => {
    if (!isAuthenticated) {
      showDialog(LoginDialogPortable, {
        title: 'Login To Claim The Rewards',
      });
      return;
    }

    claimAll(eventData.portalEventId, {
      onSuccess: async () => {
        showProcess();
        await wait(VERIFY_DURATION_MS);
        showSuccess();
      },
    });
  };

  return (
    <Button
      loading={isClaimingAll}
      onClick={handleClaimAll}
      variant="green"
      disabled={!canClaimAll}
      className="h-8 w-[110px] text-xs font-semibold"
      loadingText={t('processing')}
    >
      {t('claim_all')}
    </Button>
  );
};
